import React, { Component } from 'react';
import { asyncConnect } from 'redux-connect';
import { browserHistory } from 'react-router';
import { push } from 'react-router-redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';

import { constAPISuccess, MAX_AGE_DEVICE_ID } from '../../utils/clientConstant';
import commonUtil from '../../utils/commonUtil';
// import {
//   isLoaded as isInfoLoaded,
//   load as loadInfo,
// } from '../../redux/modules/info';
import { logout } from '../../redux/modules/auth';

import {
  loadEventDetails,
  isEventDetailsLoaded,
} from './../../components/EventDetails/actions';
import * as BrowseAndNevigateMiniCartAction from '../../pages/BrowseAndNavigate/MiniCart/actions';
import {
  _isUserinfoLoaded,
  _fetchProfileEventsInfo as fetchProfileEventsInfo,
} from '../Accounts/createAccount/actions';
import { getCSCAdminProfile } from '../BrowseAndNavigate/CscAdminProfile/actions';

import GRHeader from '../../components/GRHeader';
import GREcomHeader from '../../components/GREcomHeader';
import Breadcrumb from '../../components/Breadcrumb';
import Footer from '../../components/Footer';
import Tagging from '../../components/Tagging';

// App-level
import config from '../../config';
import serverClientUtil from '../../utils/serverClientUtil';
import * as NewMegaMenuActions from '../BrowseAndNavigate/NewMegaMenu/action';
import * as GlobalDataActions from '../BrowseAndNavigate/GlobalContent/action';
import * as labelsActions from '../../components/labels/actions';
import NewFooterComponent from '../../components/NewFooter/footer';
// import NewFooterComponentWap from '../../components/NewFooter/FooterWap';
import { resetEventManagementAddresses } from '../eventManagement/page/EventData/DeliveryAddress/actions';
import { getFavoriteStore } from '../NewHeader/actions';
import { getClientDeviceId } from '../../utils/deviceClient';
import { GetCookie } from '../eventManagement/page/GiftListGuestView/actions';

// const {
//   loadAllCategoriesData,
//   getAllCategoriesData,
//   loadLinksData,
//   getLinksMenuData,
// } = BrowseAndNevigateMegaMenuAction;
const { loadNewMegaMenu, getNewMegaMenu } = NewMegaMenuActions;
const { loadGlobalData, getGlobalData } = GlobalDataActions;
const { getCartCountData } = BrowseAndNevigateMiniCartAction;
const { isLablesLoaded, loadLables } = labelsActions;

const applicationRoutes = commonUtil.getApplicationRoutes();

const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();

@asyncConnect([
  {
    promise: ({ store: { dispatch, getState } }) => {
      if (!_isUserinfoLoaded(getState())) {
        return dispatch(fetchProfileEventsInfo());
      }
      return undefined;
    },
  },
  {
    promise: ({ store: { dispatch, getState } }) => {
      if (!loadNewMegaMenu(getState())) {
        return dispatch(getNewMegaMenu());
      }
      return undefined;
    },
  },
  {
    promise: ({ store: { dispatch, getState } }) => {
      if (!loadGlobalData(getState())) {
        return dispatch(getGlobalData());
      }
      return undefined;
    },
  },
  {
    promise: ({ store: { dispatch, getState } }) => {
      if (!isLablesLoaded(getState())) {
        return dispatch(loadLables());
      }
      return undefined;
    },
  },
  {
    promise: ({ store: { dispatch, getState } }) => {
      if (!isEventDetailsLoaded(getState())) {
        return dispatch(loadEventDetails());
      }
      return undefined;
    },
  },
])
@connect(
  (state) => ({
    user:
      state.user &&
      state.user.data &&
      state.user.data.result &&
      state.user.data.result.profileId
        ? state.user.data.result
        : null,
    footer: state.footer,
    globalObject: state.globleObject,
    eventManagementAddresses: state.deliveryAddress.eventManagementAddresses,
  }),
  {
    logout,
    getCartCountData,
    fetchProfileEventsInfo,
    resetEventManagementAddresses,
    pushState: push,
    getFavoriteStore,
    loadEventDetails,
    getCSCAdminProfile,
  },
)
export default class App extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    user: PropTypes.object,
    logout: PropTypes.func.isRequired,
    pushState: PropTypes.func.isRequired,
  };

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  static state = {
    menuVisible: false,
  };

  homepageBindclickEvent = () => {
    // handle click events on home page...
    if (typeof document !== 'undefined' && document && browserHistory) {
      if (document.querySelector('.tutorialBlock .btnPrimary')) {
        document.querySelector('.tutorialBlock .btnPrimary').addEventListener(
          'click',
          () => {
            browserHistory.push(applicationRoutes.mesaType);
          },
          false,
        );
      }
    }
  };

  loadQuantumScript = () => {
    if (serverClientUtil.enableQuantum === true) {
      const script = document.createElement('script');
      script.src = serverClientUtil.quantumURL;
      script.defer = true;
      document.head.appendChild(script);
    }
  };

  async componentDidMount() {
    this.homepageBindclickEvent();
    this.bindBodyStyleForWAP();
    this.loadTooltipInIphoneSafari();
    this.loadQuantumScript();
    this.props.getCartCountData();
    // this.props.fetchProfileEventsInfo();
    const folioId = GetCookie('x-cs-folio-id');
    if(folioId) {
      this.props.getCSCAdminProfile();
    }
    this.props.getFavoriteStore();

    const mf = document.createElement('script');
    mf.type = 'text/javascript';
    mf.async = true;
    mf.src =
      '//cdn.mouseflow.com/projects/8f4b2e00-d7d0-40e8-8b49-c96ceb6e6e95.js';
    document.getElementsByTagName('head')[0].appendChild(mf);

    const mfscript = document.createElement('script');
    mfscript.type = 'text/javascript';
    mfscript.id = 'MouseFlowID';
    const deviceId = await getClientDeviceId(commonUtil.readCookie('deviceId'));
    const subDomainName = commonUtil.createSubDomainName(window.location.host);
    commonUtil.createCookiewithSubDomain(
      'opcId',
      btoa(deviceId),
      '/',
      subDomainName,
      `max-age=${MAX_AGE_DEVICE_ID}`,
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      const shouldScroll = this.props.location?.state?.scrollToCategoryGrid;

      if (shouldScroll) {
        setTimeout(() => {
          const el = document.getElementById(
            'category-tile-crea-tu-mesa-de-regalos',
          );
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }

          const { location } = this.props;
          if (location.state && location.state.scrollToCategoryGrid) {
            location.state.scrollToCategoryGrid = false;
          }
        }, 900);
      }
      if (!document.getElementById('MouseFlowID')) {
        const mfscript = document.createElement('script');
        mfscript.type = 'text/javascript';
        document.getElementsByTagName('head')[0].appendChild(mfscript);
      }
      const prevPath = prevProps.location?.pathname;
      const currentPath = this.props.location?.pathname;
      if (prevPath !== currentPath) {
        const isAddDeliveryAddress =
          prevPath === '/crearevento/direcciondeentrega';

        const isGiftListForEvent =
          prevPath && prevPath.startsWith('/gestiondeeventos/listaderegalos/');

        const shouldSkipFlush = isAddDeliveryAddress || isGiftListForEvent;
        if (
          !shouldSkipFlush &&
          this.props.eventManagementAddresses?.length > 0
        ) {
          this.props.resetEventManagementAddresses();
        }
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.user && nextProps.user) {
      this.props.pushState('/');
    } else if (this.props.user && !nextProps.user) {
      this.props.pushState('/');
    }
    this.setState({ menuVisible: false });
  }

  bindBodyStyleForWAP = () => {
    if (document && window && channel === constChannels.WAP) {
      document
        .querySelector('body')
        .setAttribute(
          'style',
          'width: 100%;cursor: pointer;overflow-x: hidden;',
        );
    }
  };

  loadTooltipInIphoneSafari = () => {
    if (document && window) {
      const userAgent = window.navigator.userAgent;
      if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
        document.querySelector('body').style.cursor = 'pointer';
        document.querySelector('body').addEventListener('click', (bodyE) => {
          if (bodyE.target.classList.contains('tooltip-container')) {
            if (bodyE.target && bodyE.target.classList)
              bodyE.target.classList.add('tooltip-active');
          } else {
            document.querySelectorAll('.tooltip-container').forEach((ele) => {
              if (ele.classList) ele.classList.remove('tooltip-active');
            });
          }
        });
      }
    }
  };

  handleLogout = (event) => {
    event.preventDefault();
    this.props.logout();
  };

  breadcrumb = {
    route: '/home/administrator/mesaderegalos',
    displayName: 'Mesa de Regalos',
    parent: {
      route: '/',
      displayName: 'Home',
    },
  };

  toggleMenu = () => {
    this.setState({ menuVisible: !this.state.menuVisible });
  };

  isSocialContactsPage = () => {
    const yahoo = applicationRoutes.yahoo;
    const outlook = applicationRoutes.outlook;
    return (
      this.props.location.pathname.indexOf(yahoo) === 0 ||
      this.props.location.pathname.indexOf(outlook) === 0
    );
  };

  toogleHideSearchWap = () => {
    const { location } = this.props;
    const arrayStr = location.pathname.split('/');
    if (arrayStr[1] === 'gestiondeeventos' && arrayStr[2] === 'listaderegalos')
      return true;
    return false;
  };

  showHideFooter = (router) => {
    const { location = {}, params = '' } = router;
    const { pathname = '' } = location;

    // ? Rule bussines. In this urls don't show footer
    const routeDataWeb = [
      applicationRoutes.partialTransference,
      applicationRoutes.closureTransference,
    ];

    const routeDataWAP = [
      applicationRoutes.partialTransference,
      applicationRoutes.closureTransference,
    ];

    const routeData = channel === 'web' ? routeDataWeb : routeDataWAP;

    const hideFooter = routeData.some((info) => {
      const exactRoute = commonUtil.getRouteByParameter(info, params);
      return exactRoute === pathname;
    });

    return !hideFooter;
  };

  // TODO: Removed navigation
  render() {
    const { router, location } = this.props;
    const { pathname: pathnameProps } = location;
    const pathname = applicationRoutes.downloadToPDF;
    const pdf = pathname.slice(1, pathname.indexOf('('));
    const isAvailablePdf = pathnameProps.indexOf(pdf);
    const containerClassName =
      commonUtil.getChannel().toLowerCase() === 'web'
        ? 'container-fluid web-container'
        : 'container mobileView';
    const showFooter = this.showHideFooter(router);

    return (
      <React.Fragment>
        <div id='loading' style={{ display: 'none' }}>
          <Tagging ref={(tagging) => (this.tagging = tagging)} />
          <img
            id='loading-image'
            src={commonUtil.getAssetURL() + '/images/bx_loader.gif'}
            alt='Loading...'
          />
        </div>

        <Helmet {...config.app.head} />
        {isAvailablePdf >= 0 || this.isSocialContactsPage() ? (
          ''
        ) : (
          <GREcomHeader
            Router={router}
            params={this.props.params}
            isAvailableHeader={serverClientUtil.enableNewHeader}
            hideSearch={this.toogleHideSearchWap()}
            {...this.props}
          />
        )}

        {commonUtil.getChannel() === 'web' && isAvailablePdf < 0 ? (
          <div id='breadCrumbMainContainer'>
            <Breadcrumb
              className='breadcrumbbox'
              Router={router}
              params={this.props.params}
            />
          </div>
        ) : null}

        {isAvailablePdf >= 0 || this.isSocialContactsPage() ? (
          ''
        ) : (
          <GRHeader
            Router={router}
            params={this.props.params}
            {...this.props}
          />
        )}

        <div className={containerClassName}>{this.props.children}</div>
        {showFooter &&
          (channel !== 'wap' ? (
            <NewFooterComponent />
          ) : (
            <Footer router={router} />
          ))}
      </React.Fragment>
    );
  }
}
